import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DropdownButton, MenuItem } from 'react-bootstrap';

export const RowsPerPageDefault = 10;

const PageButtonWrapper = styled.div`
    button:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    button:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
`;

const PaginationWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px 10px;
`;

const PageButton = styled.button`
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.4;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
    outline: none;

    &.active {
        color: #fff;
        background-color: #337ab7;
        font-weight: bold;
    }
`;

export default class Pagination extends React.Component {
    constructor(props) {
        super();
        this.state = {
            visiblePages: this.getVisiblePages(null, props.pages),
            rowsPerPage: RowsPerPageDefault
        };

        this.changePage = this.changePage.bind(this);
    }

    static propTypes = {
        pages: PropTypes.number,
        page: PropTypes.number,
        PageButton: PropTypes.any,
        onPageChange: PropTypes.func,
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.pages !== nextProps.pages) {
            this.setState({
                visiblePages: this.getVisiblePages(null, nextProps.pages)
            });
        }
        this.changePage(nextProps.page + 1);
    }

    filterPages = (visiblePages, totalPages) => visiblePages.filter(page => page <= totalPages);

    getVisiblePages = (page, total) => {
        if (total < 7) {
            return this.filterPages([1, 2, 3, 4, 5, 6], total);
        }

        if (page > 4 && page + 2 < total) {
            return [1, page - 1, page, page + 1, total];
        } else if (page > 4 && page + 2 >= total) {
            return [1, total - 3, total - 2, total - 1, total];
        }

        return [1, 2, 3, 4, 5, total];
    };

    handleSelect(evtkey) {
        this.props.onPageSizeChange(Number(evtkey));
        this.setState({
            ...this.state, rowsPerPage: evtkey
        });
    }

    changePage(page) {
        const activePage = this.props.page + 1;
        if (page === activePage) {
            return;
        }
        const visiblePages = this.getVisiblePages(page, this.props.pages);

        this.setState({
            visiblePages: this.filterPages(visiblePages, this.props.pages)
        });

        this.props.onPageChange(page - 1);
    }

    createPageSizeOptions(data) {
        const pageSizeOptions = [RowsPerPageDefault];
        if (data.length >= 25) { pageSizeOptions.push(25); }
        if (data.length >= 50) { pageSizeOptions.push(50); }
        if (data.length >= 100) { pageSizeOptions.push(100); }

        if (data.length !== pageSizeOptions[pageSizeOptions.length - 1]) {
            pageSizeOptions.push(data.length);
        }

        return pageSizeOptions;
    }

    render() {
        const { sortedData, pageSize } = this.props;
        const { visiblePages } = this.state;
        const activePage = this.props.page + 1;
        const pageSizeOptions = this.createPageSizeOptions(sortedData);

        return (
            <PaginationWrapper>
                {!this.props.hidePageDropDown &&
                <DropdownButton
                    id='rowDropDown'
                    title={`${this.props.pageSize}`}
                    onSelect={evtkey => this.handleSelect(evtkey)}
                >
                    {pageSizeOptions.map((option, i) => (
                        <MenuItem key={i} eventKey={option} active={pageSize === option}>{i !== pageSizeOptions.length - 1 ? `${option}` : `All (${option})`}</MenuItem>
                    ))}
                </DropdownButton>}

                <PageButtonWrapper>

                    {/* PREVIOUS BUTTON */}
                    {activePage !== 1 && (
                        <PageButton
                            onClick={() => {
                                if (activePage === 1) return;
                                this.changePage(activePage - 1);
                            }}
                        >
                            {'<'}
                        </PageButton>
                    )}

                    {/* VISIBLE NUMBERS */}
                    {visiblePages.map((page, index, array) => (
                        <PageButton
                            key={page}
                            className={
                                activePage === page && 'active'
                            }
                            onClick={this.changePage.bind(null, page)}
                        >
                            {array[index - 1] + 2 <= page ? `...${page}` : page}
                        </PageButton>
                    ))}

                    {/* NEXT BUTTON */}
                    {activePage !== this.props.pages && (
                        <PageButton
                            onClick={() => {
                                if (activePage === this.props.pages) return;
                                this.changePage(activePage + 1);
                            }}
                        >
                            {'>'}
                        </PageButton>
                    )}
                </PageButtonWrapper>
            </PaginationWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/molecules/tables/components/Pagination.js